import getClamConfig from './getClamConfig';

export * from './types';
export default getClamConfig;
